import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import * as _ from 'lodash';

import WrapperSecondary from '../../common/WrapperSecondary';
import Create from '../../goals/create/';
import GoalsList from '../../goals/List';
import Button from '../../common/Button';

class Screen extends React.Component {
  render() {
    const { goals, user, t } = this.props;

    return (
      <WrapperSecondary
        title={t('onboarding.addGoals.title')}
        subtitle={t('onboarding.addGoals.subtitle')}
      >
        <h3 className="c-heading--alpha u-margin-bottom-tiny">
          {t('onboarding.addGoals.addGoals')}
        </h3>
        <p>{t('user.noneGoalsAddedMotivation')}</p>
        <div className="o-box c-box o-box--with-vertical-indent">
          <Create />
        </div>

        {!_.isEmpty(goals) && (
          <h3 className="c-heading--alpha u-margin-top-huge">
            {t('onboarding.addGoals.addedGoals')}
          </h3>
        )}
        <GoalsList enableEmptyState={false} user={user.data} />

        <div className="u-margin-top-large u-text-center">
          <Button
            styleType="tertiary"
            onClick={() => this.props.history.push('/home')}
          >
            {t('onboarding.addGoals.continueBtn')}
          </Button>
        </div>
      </WrapperSecondary>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  goals: user.data && user.data.goals,
  user,
});

export default connect(mapStateToProps)(translate()(Screen));



// WEBPACK FOOTER //
// ./src/onboarding/add-goals/Screen.js